export const formatPhone = (raw) => {
  if (!raw) return "";
  const cleaned = raw.replace(/\D/g, "");
  if (cleaned.length !== 10) return raw; // fallback if not 10 digits
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};
